import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { IosUploadDialogComponent } from './ios-upload-dialog.component';
import { CommonModule } from '@angular/common';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		IosUploadDialogComponent
	],
	exports: [
		IosUploadDialogComponent
	]
})
export class IosUploadDialogModule {}
